import React from 'react';
import RunningActivityModal from './RunningActivityModal';
import CyclingActivityModal from '../Cycling/CyclingActivityModal';
import SwimmingActivityModal from '../Swimming/SwimmingActivityModal';
import StrengthActivityModal from '../Strength/StrengthActivityModal';

const ActivityDetailsModal = (props) => {
  const { activityType } = props;

  if (!activityType) {
    console.warn("❌ activityType está vacío en ActivityDetailsModal");
    return null;
  }

  const normalizedType = activityType.type?.toLowerCase();
  console.log("📌 activityType recibido:", normalizedType);

  switch (normalizedType) {
    case 'ciclismo':
      return <CyclingActivityModal {...props} />;
    case 'nadar':
      return <SwimmingActivityModal {...props} />;
    case 'fuerza':
      return <StrengthActivityModal {...props} />;
    default:
      return <RunningActivityModal {...props} />;
  }
};

export default ActivityDetailsModal;
